import { Component } from '@angular/core';
export class AmdDialogComponent {
    constructor() {
        this.isOpen = true;
    }
    /**
     * @return {?}
     */
    closeModal() {
        this.isOpen = false;
    }
}
AmdDialogComponent.decorators = [
    { type: Component, args: [{
                selector: 'amd-dialog',
                template: "<div class=\"amd-modal\" [class.is-open]=\"isOpen\"> <div class=\"amd-modal-backdrop\" (click)=\"closeModal()\"></div> <div class=\"amd-modal-content\"> <ng-content></ng-content> </div> </div>"
            },] },
];
/**
 * @nocollapse
 */
AmdDialogComponent.ctorParameters = () => [];
function AmdDialogComponent_tsickle_Closure_declarations() {
    /** @type {?} */
    AmdDialogComponent.decorators;
    /**
     * @nocollapse
     * @type {?}
     */
    AmdDialogComponent.ctorParameters;
    /** @type {?} */
    AmdDialogComponent.prototype.isOpen;
}
//# sourceMappingURL=dialog.component.js.map
//# sourceMappingURL=dialog.component.js.map
